<template>
  <div class="dialog-wrap">
    <el-dialog title="分数线编辑"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open"
               :append-to-body="true"
               width="500px">
      <div class="content">
        <div class="modular">
          <div class="title">
            <div class="line"></div>
            <div class="text">基本信息</div>
          </div>
          <div class="padding">
            <el-form class="search-wrap"
                     ref="formRules"
                     :model="dataForm"
                     :rules="rules"
                     label-width="100px"
                     label-position="left">
              <el-form-item label="考研年份："
                            prop="year">
                <el-select v-model="dataForm.year"
                           filterable
                           placeholder="请选择"
                           clearable
                           style="width: 100%">
                  <el-option v-for="(item, index) in filter.years"
                             :key="index"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="院校名称："
                            prop="college">
                <el-select v-model="dataForm.college"
                           filterable
                           placeholder="请选择"
                           @change="collegeChange"
                           style="width: 100%"
                           clearable>
                  <el-option v-for="(item, index) in $store.state.collegeList"
                             :key="index"
                             :label="item.name"
                             :value="{ value: item.code, label: item.name }">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="专业名称："
                            prop="major">
                <el-select v-model="dataForm.major"
                           placeholder="请选择"
                           filterable
                           clearable
                           @change="majorChange"
                           style="width: 100%">
                  <el-option v-for="(item, index) in majorList"
                             :key="index"
                             :label="item.name"
                             :value="{ value: item.code, label: item.name }">
                    <span>{{ `（${item.code}）${item.name}` }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学院名称："
                            prop="academy">
                <el-select v-model="dataForm.academy"
                           placeholder="请选择"
                           filterable
                           clearable
                           style="width: 100%"
                           @change="academyChange">
                  <el-option v-for="(item, index) in academylist"
                             :key="index"
                             :label="item.academy_name"
                             :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
                    <span>{{
                      `（${item.academy_code}）${item.academy_name}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="方向名称："
                            prop="direction">
                <el-select v-model="dataForm.direction"
                           placeholder="请选择"
                           filterable
                           style="width: 100%"
                           clearable>
                  <el-option v-for="(item, index) in directionlist"
                             :key="index"
                             :label="item.direction"
                             :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
                    <span>{{
                      `（${item.direction_code}）${item.direction}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>

            </el-form>
          </div>
        </div>
        <div class="modular"
             style="margin-top: 32px">
          <div class="title">
            <div class="line"></div>
            <div class="text">科目</div>
          </div>
          <div class="padding">
            <el-form class="dash-wrap"
                     label-width="90px"
                     label-position="left">
              <el-form-item label="总分：">
                <el-input placeholder=""
                          v-model="dataForm.score_total"
                          style="width: 100%">
                  <template slot="append">分</template>
                </el-input>
              </el-form-item>
              <el-form-item label="政治：">
                <el-input placeholder=""
                          v-model="dataForm.score_politics"
                          style="width: 100%">
                  <template slot="append">分</template>
                </el-input>
              </el-form-item>
              <el-form-item label="外语：">
                <el-input placeholder=""
                          v-model="dataForm.score_language"
                          style="width: 100%">
                  <template slot="append">分</template>
                </el-input>
              </el-form-item>
              <el-form-item label="业务课一：">
                <el-input placeholder=""
                          v-model="dataForm.score_business_1"
                          style="width: 100%">
                  <template slot="append">分</template>
                </el-input>
              </el-form-item>
              <el-form-item label="业务课二：">
                <el-input placeholder=""
                          v-model="dataForm.score_business_2"
                          style="width: 100%">
                  <template slot="append">分</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer"
           class="footer">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
      
<script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { scoreLinePut, scoreLineDetail } from '@/api/admission'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    editId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {},
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
      },
      majorList: [],
      academylist: [],
      directionlist: [],
      plan_last_count_switch: 1,
      college_major_adjust_source: '',
      college_major_adjust_target: '',
      arr_college_score_line: [],
      subjects: [],
      reference_books: '',
      concat: {},
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.dataForm = {}
        this.majorList = []
        this.academylist = []
        this.directionlist = []
      }
    },
  },
  created() {},
  methods: {
    open() {
      this.fetchDetail()
    },
    fetchDetail() {
      scoreLineDetail({ id: this.editId }).then((res) => {
        console.log('查询详情', res)
        this.$set(this.dataForm, 'year', Number(res.year))
        this.$set(this.dataForm, 'college', {
          label: res.college_name,
          value: res.college_code,
        })
        this.fetchMajor(res.college_code)
        this.$set(this.dataForm, 'major', {
          label: res.major_name,
          value: res.major_code,
        })
        this.fetchMajorInfo(res.college_code, res.major_code).then((info) => {
          const academys = info.academys || []
          const target = academys.find(
            (v) => v.academy_code === res.academy_code
          )
          if (target && Array.isArray(target.directions)) {
            this.directionlist = target.directions
          } else if (res.direction_code) {
            this.directionlist = [
              {
                direction_code: res.direction_code,
                direction: res.direction_name,
              },
            ]
          } else {
            this.directionlist = []
          }
        })
        this.$set(this.dataForm, 'academy', {
          label: res.academy_name,
          value: res.academy_code,
        })
        this.$set(this.dataForm, 'direction', {
          label: res.direction_name,
          value: res.direction_code,
        })

        this.$set(this.dataForm, 'score_total', res.score_total)
        this.$set(this.dataForm, 'score_politics', res.score_politics)
        this.$set(this.dataForm, 'score_language', res.score_language)
        this.$set(this.dataForm, 'score_business_1', res.score_business_1)
        this.$set(this.dataForm, 'score_business_2', res.score_business_2)
        this.$forceUpdate()
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.fetchMajor(e.value)
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    majorChange(e) {
      this.fetchMajorInfo(this.dataForm.college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      return new Promise((resolve) => {
        majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
          this.academylist = res.academys
          resolve(res)
        })
      })
    },
    academyChange(e) {
      this.directionlist = e.directions
    },
    switchChange(e) {
      if (e == 0) {
        this.$set(this.dataForm, 'plan_last_count', 1)
      } else if (e == 1) {
        this.$set(this.dataForm, 'plan_last_count', '')
      }
    },
    handleClose() {
      this.majorList = []
      this.academylist = []
      this.directionlist = []
      this.$emit('close')
    },

    submit(rules) {
      let data = {
        id: this.editId,
        year: this.dataForm.year,
        college_name: this.dataForm.college.label,
        college_code: this.dataForm.college.value,
        academy_code: this.dataForm.academy.value,
        academy_name: this.dataForm.academy.label,
        major_code: this.dataForm.major.value,
        major_name: this.dataForm.major.label,
        direction_code: this.dataForm.direction.value,
        direction_name: this.dataForm.direction.label,
        enrol_type: 1,
        score_total: this.dataForm.score_total,
        score_politics: this.dataForm.score_politics,
        score_language: this.dataForm.score_language,
        score_business_1: this.dataForm.score_business_1,
        score_business_2: this.dataForm.score_business_2,
      }
      scoreLinePut(data).then((res) => {
        this.handleClose()
        this.$emit('submit')
        this.$message.success('修改成功')
      })
      // this.$refs[rules].validate((valid) => {
      //   if (valid) {
      //     const data = {
      //       id: this.id,
      //       college_name: this.dataForm.college.label,
      //       college_code: this.dataForm.college.value,
      //       year: this.dataForm.year,
      //       academy_code: this.dataForm.academy.value,
      //       academy_name: this.dataForm.academy.label,
      //       major_code: this.dataForm.major.value,
      //       major_name: this.dataForm.major.label,
      //       direction_code: this.dataForm.direction.value,
      //       direction_name: this.dataForm.direction.label,
      //       enrol_type: this.dataForm.enrol_type,
      //       plan_last_count: this.dataForm.plan_last_count,
      //       adjust_demand: this.dataForm.adjust_demand,
      //       _delete: this.dataForm._delete,
      //     }
      //     adjustAdminEdit(data).then((res) => {
      //       this.handleClose()
      //       this.$emit('submit')
      //       this.$message.success('创建成功')
      //     })
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 16px 0px;
}
.between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content {
  overflow-y: hidden;
  .modular {
    .title {
      display: flex;
      align-items: center;
      .line {
        width: 4px;
        height: 22px;
        background: #266fe8;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
      }
      .text {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303133;
        margin-left: 26px;
      }
    }
    .padding {
      padding: 16px 30px;
    }
  }
}
.dash-wrap {
  & + .dash-wrap {
    margin-top: 32px;
  }
  padding: 20px;
  padding-bottom: 0px;
  border: dashed 1px #999;
  border-radius: 4px;
}
</style>
      